//
// $FlowFixMe
import styled from 'styled-components';
import { FlexRow } from '../../globals';

export const Actions = styled(FlexRow)`
  margin-top: 24px;
  padding: 0 24px 40px;
  justify-content: center;

  button + button {
    margin-left: 8px;
  }
`;

export const Message = styled.div`
  font-size: 16px;
  line-height: 1.4;
  margin: 8px 24px;
  text-align: center;
  color: #73747d;
  p {
    margin-top: 8px;
  }

  b {
    font-weight: 700;
  }
`;
